import { MissionVisibilityLabel } from '@domain/labels';
import { MissionVisibility } from '@wwf/sdk';

export const findMissionVisibilityLabel = (
    missionVisibilityList: MissionVisibilityLabel[],
    missionVisibility: MissionVisibility
) => {
    return missionVisibilityList.find(mv => mv.value === missionVisibility);
};
